// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".emoji-dialog[data-v-388c2ba2]::before {\n    display: none\n}", "",{"version":3,"sources":["/home/ubuntu/chatwoot/chatwoot/app/javascript/dashboard/routes/dashboard/helpcenter/pages/categories/NameEmojiInput.vue"],"names":[],"mappings":"AAEE;IAAA;AAAA","file":"NameEmojiInput.vue","sourcesContent":["\n.emoji-dialog::before {\n  @apply hidden;\n}\n"]}]);
// Exports
module.exports = exports;
